document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.mySwiper', {
      spaceBetween: 30,
      centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 1800,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="dot swiper-pagination-bullet"></span>`;
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    var swiperTestimonials = new Swiper('.mySwiperTestimonials', {
        spaceBetween: 30,
        centeredSlides: true,
        loop: false,
        autoplay: {
          delay: 7000,
          disableOnInteraction: true,
        },
        pagination: {
          el: '.swiper-pagination-testimonials',
          clickable: true,
        },
        loopAdditionalSlides: 0,
      });
  
      swiperTestimonials.on('init', function() {
        console.log('Swiper Testimonils is ready!');
        // Your custom code to run when Swiper is ready
      });

      var swiperLA = new Swiper('.mySwiperLatestArticles', {
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 10000,
          disableOnInteraction: true,
        },
        pagination: {
          el: '.swiper-pagination-latest-articles',
          clickable: true,
        },
        slidesPerView: 1,
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView:2,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        },
      });
  
      swiperLA.on('init', function() {
        console.log('Swiper Latest Articles is ready!');
        // Your custom code to run when Swiper is ready
      });

    // Mobile Nav Bar JS
    var sideMenu = document.getElementById('side-menu');

    function openMenu() {
      sideMenu.classList.remove('right-[-250px]');
      sideMenu.classList.add('right-0');
    }

    function closeMenu() {
      sideMenu.classList.remove('right-0');
      sideMenu.classList.add('right-[-250px]');
    }
  const button = document.querySelector('#menu-button');
  const menu = document.querySelector('#menu');
  window.onscroll = function() {scrollFunction()};

  function scrollFunction() {
    const navBannerBlock = document.querySelector(".nav-banner-block");
    const navBannerBlockMob = document.querySelector(".nav-banner-block-mob");
    if(navBannerBlock && navBannerBlockMob){
      if (document.scrollingElement.scrollTop > 50) {
        navBannerBlock.style.paddingTop = "1rem";
        navBannerBlock.style.paddingBottom = "1rem";
        navBannerBlock.style.height = "";
        navBannerBlockMob.style.paddingTop = "0.25rem";
        navBannerBlockMob.style.paddingBottom = "0.25rem";
        navBannerBlockMob.style.height = "";
      } else {
        navBannerBlock.style.paddingTop = "2rem";
        navBannerBlock.style.paddingBottom = "2rem";
        navBannerBlock.style.height = "120px";
        navBannerBlockMob.style.paddingTop = "0.5rem";
        navBannerBlockMob.style.paddingBottom = "0.5rem";
        navBannerBlockMob.style.height = "80px";
      }
    }
  }

  button.addEventListener('click', () => {
    console.log("clickedddd");
    menu.classList.toggle('hidden');
  });
});